module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('div', {
    attrs: {
      "id": "hs_root"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ee93402","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/custom/HsOrder.vue
// module id = 106
// module chunks = 0 1 2